import { httpRequest } from '@/shared/lib/http';

export interface ApiError {
  message: string | string[];
  error: string;
  statusCode: number;
}

// Interfaz extendida para opciones personalizadas
interface RequestOptions extends RequestInit {
  skipGlobalErrorHandler?: boolean;
}

export class ApiService {

  /**
   * Delega en el cliente HTTP compartido. La firma no cambia: los 121 lugares
   * que llaman a este metodo siguen igual.
   */
  public async request<T>(
    endpoint: string,
    options: RequestOptions = {}
  ): Promise<T> {
    const { skipGlobalErrorHandler, ...init } = options;
    const datos = await httpRequest<T>(endpoint, {
      ...init,
      skipAuthRedirect: skipGlobalErrorHandler,
    });
    // Este metodo siempre devolvio un objeto, nunca undefined: se conserva para
    // no romper a quien accede a una propiedad del resultado sin revisar.
    return datos ?? ({} as T);
  }
}

export const apiService = new ApiService();